import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import * as FacilitiesActions from './../actions/facilities_actions';
import * as SettingScreen from '../actions/settingScreen_actions';
import { bindActionCreators } from 'redux';
import { validate } from '../validations';
import { ModalDialogCommon } from './modal_dialog_common';

let Loging = React.createClass({
    getInitialState() {
        return {
            isPassword_submited: null,
            errorMessage: null,
            modal_msg: null, Changepassword: false,
            isResetPasswordSucceeded: false, confirmPasswordTyped: false,
        }
    },

    componentWillMount() {

        // redirection to login page, if User clicks on browser back after password update.
        // if (!this.props.Setting.allRandomSecurityQuestions) {

        // if( validate.getUrlParam('passwordChanged')){
        //   return;
        // }else{
        //   this.props.router.push('/');
        //   return;
        // }

        // }
    },

    componentWillReceiveProps(nextProps) {

        if (this.state.isPassword_submited && nextProps.Setting.Changepassword.status === 200) {
            this.setState({ isPassword_submited: null });
            nextProps.Setting.Changepassword.status ?
                this.setState({ modal_msg: nextProps.Setting.Changepassword.message }) :
                this.setState({ modal_msg: null })
            nextProps.Setting.Changepassword.status === 200 ? this.setState({ isResetPasswordSucceeded: true }) : this.setState({ isResetPasswordSucceeded: false });

        } else if (nextProps.UserDetails.logout && this.state.isResetPasswordSucceeded) {
            localStorage.clear();
            this.props.router.push('/');
        } else {
            this.setState({ errorMessage: nextProps.Setting.Changepassword.message })
        }

    },
    closeBoxOnScuess() {

        this.refs.password.value = '';
        this.refs.confirmPassword.value = '';
        this.setState({ modal_msg: null });
        if (this.state.isResetPasswordSucceeded === true) {
            localStorage.clear();
            this.props.Dispatch(UserActions.user_log_out());
        }

    },
    validatePassword() {
        let isValidpassword = validate.isValidPassword(this.refs.password.value.trim());
        isValidpassword ? this.refs.password.className = 'inputText' : this.refs.password.className = 'inputText error';
        if (isValidpassword) {
            this.setState({
                password: this.refs.password.value,
                errorMessage: null,
            })
        } else {
            this.setState({
                password: null,
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            })
        }
        return isValidpassword;
    },

    validateConfirmPassword() {
        let isValidConfirmpassword = validate.isValidPassword(this.refs.confirmPassword.value.trim());
        isValidConfirmpassword ? this.refs.confirmPassword.className = 'inputText' : this.refs.confirmPassword.className = 'inputText error';
        if (!isValidConfirmpassword) {
            this.setState({
                password: null,
                errorMessage: "Password must contain at least 12 characters, including uppercase, lowercase letters, special character and numbers."
            });
            return false;
        }
        if (isValidConfirmpassword && (this.refs.password.value === this.refs.confirmPassword.value)) {
            this.setState({
                password: this.refs.password.value,
                errorMessage: null,
            })
            return true;
        }
        else {
            this.setState({
                password: null,
                errorMessage: "Password and Confirm Password fields should match."
            })
            this.refs.confirmPassword.className = 'inputText error';
            return false;
        }
    },

    update() {

        if (this.refs.password.value.trim() != "" && this.refs.confirmPassword.value.trim() != "") {
            if (this.validateConfirmPassword()) {
                console.log();
                // validate.getUrlParam('id')
                var data = {
                    "id": this.props.location.query.id.split('?')[0],
                    "uniqueKey": validate.getUrlParam('k'),
                    "password": this.refs.confirmPassword.value,
                    "isPasswordChange": 0
                }

                this.setState({ isPassword_submited: true });
                this.props.Dispatch(SettingScreen.changePassword(data));
            }
        } else {
            this.setState({
                errorMessage: "Please enter necessary fields to proceed."
            })
        }
    },
    remove_error(event) {
        event.target.className = 'inputText';
    },
    confirmPasswordChanged(event) {
        let conpwd = this.refs.confirmPassword.value.trim();
        if (validate.isValidPassword(conpwd) && this.validateConfirmPassword()) {
            this.setState({ confirmPasswordTyped: true })
        } else {
            this.setState({ confirmPasswordTyped: false })
        }
    },

    togglePassword() {
        var pwd = document.getElementById("password");
        pwd.type === "password" ? pwd.type = "text" : pwd.type = "password";
    },

    toggleConfirmPassword() {
        var confirmPwd = document.getElementById("confirmPassword");
        confirmPwd.type === "password" ? confirmPwd.type = "text" : confirmPwd.type = "password";
    },
    render() {
        return (
            <div className="vertalign-container">
                <div className="vertalign-child">
                    <div className="admin-login login-box">
                        <h1 className="top-logo">MOBI</h1>
                        <div className="input-group">
                            <input type="password" className="inputText" required ref='password' id="password" onFocus={this.remove_error} onBlur={this.validatePassword} />
                            <span className="floating-label">New Password</span>

                            <img src={require('./../images/eye-open.png')} className='eye-icon' onClick={() => { this.togglePassword() }} />
                        </div>
                        <div className="input-group">
                            <input type="password" className="inputText" required ref='confirmPassword' id="confirmPassword" onChange={this.confirmPasswordChanged} onFocus={this.remove_error} onBlur={this.validateConfirmPassword} />
                            <span className="floating-label">Confirm Password</span>
                            <img src={require('./../images/eye-open.png')} className='eye-icon' onClick={() => { this.toggleConfirmPassword() }} />
                        </div>

                        {this.state.errorMessage && <div className="error-message">
                            <span className="red-color">{this.state.errorMessage} </span>
                        </div>}
                        <div> {this.state.modal_msg && <ModalDialogCommon message={this.state.modal_msg} action={this.closeBoxOnScuess} />}</div>
                        {this.state.confirmPasswordTyped && <button className="gray-button admin-login-button" onClick={this.update}>Update Password</button>}
                    </div>
                </div>
            </div>
        );
    }
});

let mapStateToProps = (state) => {
    return {
        UserDetails: state.User,
        Setting: state.Setting,
        LogingDetails: state.User.loginData,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    SettingScreen: bindActionCreators(SettingScreen, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(Loging));



/** WEBPACK FOOTER **
 ** ./src/components/newPassword.js
 **/